// extracted by css-extract-rspack-plugin
export default {"BrandCircle":"Zcroh","IconMargin":"N1OW3"};